import { render, staticRenderFns } from "./rulesList.vue?vue&type=template&id=3deae6eb&scoped=true"
import script from "./rulesList.vue?vue&type=script&lang=js"
export * from "./rulesList.vue?vue&type=script&lang=js"
import style0 from "./rulesList.vue?vue&type=style&index=0&id=3deae6eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deae6eb",
  null
  
)

export default component.exports